import { FC } from "react";
import { Navigate } from "react-router-dom";
import { useUserRoute } from "../../utils/hooks/useUserRoute.hook";
import { generateLiveResourcesPath } from "../accounts-group/utils/helpers/generateLiveResourcesPath";
import { useAppSelector } from "@/store/hooks";
import { useAppAbility } from "@/services/permissions";
import { initialAccountsLoadingSelector } from "@/store/accounts/selectors/loadings/initialAccountsLoadingSelector";
import { biggestOrgSelector } from "@/store/accounts/selectors/all-providers/biggestOrgSelector";
import { firstExistingAccountSelector } from "@/store/accounts/selectors/slice-data/firstExistingAccountSelector";

export const RedirectPage: FC = () => {
  const { cannot } = useAppAbility();
  const cannotView = cannot("view", "account");
  const userLastVisitedPage = useUserRoute(false);

  const accountsLoading = useAppSelector(initialAccountsLoadingSelector);

  const firstAccount = useAppSelector(firstExistingAccountSelector);
  const biggestOrg = useAppSelector(biggestOrgSelector);

  if (cannotView) {
    return <Navigate to="/access-denied" replace />;
  }

  if (accountsLoading) {
    return null;
  }

  if (userLastVisitedPage && firstAccount) {
    return <Navigate to={userLastVisitedPage} />;
  }

  if (firstAccount || biggestOrg) {
    return (
      <Navigate
        to={generateLiveResourcesPath({
          provider: biggestOrg?.provider ?? firstAccount?.type ?? "aws",
          orgId:
            biggestOrg?.orgId ??
            firstAccount?.provider_organisation_account_id ??
            "",
        })}
      />
    );
  }

  return <Navigate to="/account/setup" />;
};
